export default {
  namespaced: true,
  state: {
    from: null,
    to: null,
  },
  mutations: {
    SET_FILTERS (state, from, to) {
      state.from = from;
      state.to = to;
    },
  },
};
